import { render, staticRenderFns } from "./CardAddressItem.vue?vue&type=template&id=71f0e270&scoped=true&"
import script from "./CardAddressItem.vue?vue&type=script&lang=js&"
export * from "./CardAddressItem.vue?vue&type=script&lang=js&"
import style0 from "./CardAddressItem.vue?vue&type=style&index=0&id=71f0e270&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f0e270",
  null
  
)

export default component.exports